var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import { View, createStyleSheet, useStyleSheet, useThemeContext, Button } from '@gopeerproject/ui-kit';
import { RangeCalendar, DateInput } from './components';
import { CalendarDropdownProvider, useCalendarDropdownContext } from './contexts';
import { useOutsideAlerter } from '../../hooks';
const formatDate = (date) => moment().isSame(date, 'd')
    ? 'Today'
    : moment(date).format(moment().isSame(date, 'y') ? 'MMM D' : 'MMM D, YYYY');
const CalendarDropdownFn = (_a) => {
    var { disabled = false, hidden = false, direction = 'bottom' } = _a, props = __rest(_a, ["disabled", "hidden", "direction"]);
    const styles = useStyleSheet(getStyles);
    const { size } = useThemeContext();
    const { from, to, isOpen, setIsOpen } = useCalendarDropdownContext();
    const ref = useRef(null);
    useOutsideAlerter(ref, () => {
        setDropdownTop(0);
        setDropdownLeft(0);
        setIsOpen(false);
    });
    const dropdownRef = useRef(null);
    const [dropdownTop, setDropdownTop] = useState(0);
    const [dropdownLeft, setDropdownLeft] = useState(0);
    useEffect(() => {
        const dropdown = dropdownRef.current;
        if (dropdown instanceof HTMLElement) {
            const rect = dropdown.getBoundingClientRect();
            const bodyHeight = document.body.offsetHeight;
            const bodyWidth = document.body.offsetWidth;
            if (rect.bottom > bodyHeight)
                setDropdownTop(rect.bottom - bodyHeight + size.K);
            if (rect.right > bodyWidth)
                setDropdownLeft(rect.right - bodyWidth + size.K);
        }
    }, [isOpen, size]);
    const labelText = `
      ${from ? formatDate(from) : 'Start date'} - 
      ${to ? formatDate(to) : 'End date'}`;
    return (React.createElement(View, { style: styles.container, ref: ref },
        React.createElement(Button, { type: hidden ? 'tertiary' : 'secondary', disabled: disabled, accent: 'neutral', size: 'md', text: labelText, onPress: () => {
                setIsOpen(!isOpen);
            }, leftIcon: 'calendar' }),
        isOpen && (React.createElement(View, { style: [
                styles.dropdown,
                direction === 'right'
                    ? styles.dropdown__right
                    : styles.dropdown__bottom,
                {
                    transform: [
                        { translateY: -dropdownTop },
                        { translateX: -dropdownLeft }
                    ]
                }
            ], ref: dropdownRef },
            React.createElement(RangeCalendar, Object.assign({}, props))))));
};
const CalendarDropdown = (_a) => {
    var { disabled, hidden, displayLabels, rangeContainerStyle, hideWeekdaysDivider, direction } = _a, args = __rest(_a, ["disabled", "hidden", "displayLabels", "rangeContainerStyle", "hideWeekdaysDivider", "direction"]);
    return (React.createElement(CalendarDropdownProvider, Object.assign({}, args),
        React.createElement(CalendarDropdownFn, Object.assign({}, {
            direction,
            disabled,
            hidden,
            displayLabels,
            rangeContainerStyle,
            hideWeekdaysDivider
        }))));
};
const getStyles = createStyleSheet(({ size, color }) => ({
    container: { flexDirection: 'row', alignSelf: 'flex-start' },
    dropdown: {
        width: 458,
        borderRadius: size.G,
        backgroundColor: color.bg.v3,
        shadowColor: 'rgba(28, 29, 40, 0.1)',
        shadowOffset: { width: 0, height: 8 },
        shadowRadius: 42,
        padding: size.C,
        gap: size.C,
        position: 'absolute',
        zIndex: 99
    },
    dropdown__right: { left: '100%', marginLeft: size.C },
    dropdown__bottom: { top: '100%', marginTop: size.C }
}));
export { RangeCalendar, CalendarDropdown, CalendarDropdownProvider, DateInput };
//# sourceMappingURL=index.js.map